import { Grid } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { HelpPanel } from "components/HelpPanel/HelpPanel";
import {
  FEATURE_INTRO_DATES,
  NewFeature,
} from "components/NewFeature/NewFeature";
import { FormikErrors } from "formik";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";
import { AchievementActivity, AchievementFEFormat } from "types/achievements";
import { SelectedLimitType } from "types/campaigns";
import { TimeframeSection } from "./Sections/AvailabilitySection";
import { LimitsSection } from "./Sections/LimitsSection";
import { NameSection } from "./Sections/NameSection";
import { StatusSection } from "./Sections/StatusSection";

interface Props {
  translations: { description?: string; locale?: string; name?: string }[];
  availableLanguages: DefaultLanguageDataState[];
  activity: AchievementActivity;
  limit: SelectedLimitType;
  errors?: any;
  setFieldValue: (field: string, value: any) => void;
  setErrors: (errors: FormikErrors<AchievementFEFormat>) => void;
}

export const AchievementInfo = ({
  translations,
  availableLanguages,
  activity,
  limit,
  errors,
  setErrors,
  setFieldValue,
}: Props) => {
  return (
    <Grid container spacing={12}>
      <Grid item xs={8}>
        <FormSection>
          <NameSection
            translations={translations}
            availableLanguages={availableLanguages}
            errors={errors}
          />
          <TimeframeSection
            setFieldValue={setFieldValue}
            activity={activity}
            errors={errors}
            setErrors={setErrors}
          />
          <LimitsSection
            limit={limit}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <StatusSection />
        </FormSection>
      </Grid>
      <Grid item xs={4}>
        <HelpPanel
          title="availability"
          description="achievementAvailabilityHelpInfo"
          links={[
            {
              label: "documentation",
              path: "https://help.openloyalty.io/main-features/achievements",
            },
          ]}
        />
        <HelpPanel
          title="badges"
          titleAdditionalInfo={
            <NewFeature featureIntroductionDate={FEATURE_INTRO_DATES.BADGES} />
          }
          description="badgesLimitHelpInfo"
          links={[
            {
              label: "documentation",
              path: "https://help.openloyalty.io/main-features/achievements/badges",
            },
          ]}
        />
        <HelpPanel
          title="limits"
          description="achievemetLimitHelpInfo"
          infoBoxText="achievementLimitInfoBox"
        />
      </Grid>
    </Grid>
  );
};
